<template>
  <div :class="classData">
    <el-checkbox
      class="mb-2"
      v-if="showComparate"
      v-model="model.comparate"
      :change="onChecked()"
      >{{ $t('common_words.compare') }}</el-checkbox
    >
    <label v-else :class="`label-primary`" style="color: transparent"
      >&nbsp;&nbsp;</label
    >
    <br />
    <l-button
      wide
      type="info"
      :class="`btn-filter`"
      style="width: inherit"
      @click="handleClick()"
    >
      {{ $t('common_words.filter') }}
    </l-button>
  </div>
</template>
<script>
export default {
  name: 'button-filter',
  props: {
    classData: {
      type: String,
      default: '',
    },
    showComparate: {
      type: Boolean,
      default: false,
    },
    initialValue: {
      type: Boolean,
    },
  },
  data() {
    return {
      model: {
        comparate: this.initialValue,
      },
    };
  },
  methods: {
    onChecked() {
      this.$emit('handledOnChecked', this.model.comparate);
    },

    handleClick() {
      this.$emit('validate');
    },
  },
};
</script>
